// Copyright Laserfiche.
// Licensed under the MIT License. See LICENSE in the project root for license information.

export class uniLocalizedFormat {
  DateFormat!: string;
  TimeFormat!:string;
  TimeFormatWithSeconds!: string;
}
export const uniLocalizedFormats: Record<string, uniLocalizedFormat> = {
    "ar-AE": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-BH": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-DZ": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-EG": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-IQ": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-JO": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-KW": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-LB": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-LY": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-MA": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "ar-MR": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-OM": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-QA": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-SA": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-SD": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-SO": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-SS": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-SY": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-TD": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-TN": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "ar-YE": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-AE": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-AG": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-AI": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-AS": {
        "DateFormat": "M/D/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-AT": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-AU": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-BB": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-BE": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-BI": {
        "DateFormat": "M/D/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-BM": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-BS": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-BW": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-BZ": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-CA": {
        "DateFormat": "YYYY-MM-DD",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-CC": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-CH": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-CK": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-CM": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-CX": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-CY": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-DE": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-DK": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH.mm",
        "TimeFormatWithSeconds": "HH.mm:ss",
    },
    "en-DM": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-ER": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-FI": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "H.mm",
        "TimeFormatWithSeconds": "H.mm:ss",
    },
    "en-FJ": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-FK": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-FM": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-GB": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-GD": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-GG": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-GH": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-GI": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-GM": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-GU": {
        "DateFormat": "M/D/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-GY": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-HK": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-IE": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-IL": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "H:mm",
        "TimeFormatWithSeconds": "H:mm:ss",
    },
    "en-IM": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-IN": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-IO": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-JE": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-JM": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-KE": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-KI": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-KN": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-KY": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-LC": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-LR": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-LS": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-MG": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-MH": {
        "DateFormat": "M/D/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-MO": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-MP": {
        "DateFormat": "M/D/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-MS": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-MT": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-MU": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-MW": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-MY": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-NA": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-NF": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-NG": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-NL": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-NR": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-NU": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-NZ": {
        "DateFormat": "D/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-PG": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-PH": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-PK": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-PN": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-PR": {
        "DateFormat": "M/D/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-PW": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-RW": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-SB": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-SC": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-SD": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-SE": {
        "DateFormat": "YYYY-MM-DD",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-SG": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-SH": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-SI": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-SL": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-SS": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-SX": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-SZ": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-TC": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-TK": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-TO": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-TT": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-TV": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-TZ": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-UG": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-UM": {
        "DateFormat": "M/D/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-US": {
        "DateFormat": "M/D/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-VC": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-VG": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-VI": {
        "DateFormat": "M/D/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-VU": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-WS": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-ZA": {
        "DateFormat": "YYYY/MM/DD",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "en-ZM": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "en-ZW": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "es-AR": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "es-BO": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "es-BR": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "es-BZ": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "es-CL": {
        "DateFormat": "DD-MM-YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "es-CO": {
        "DateFormat": "D/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "es-CR": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "es-CU": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "es-DO": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "es-EC": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "es-ES": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "H:mm",
        "TimeFormatWithSeconds": "H:mm:ss",
    },
    "es-GQ": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "H:mm",
        "TimeFormatWithSeconds": "H:mm:ss",
    },
    "es-GT": {
        "DateFormat": "D/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "es-HN": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "es-MX": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "H:mm",
        "TimeFormatWithSeconds": "H:mm:ss",
    },
    "es-NI": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "es-PA": {
        "DateFormat": "MM/DD/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "es-PE": {
        "DateFormat": "D/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "es-PH": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "es-PR": {
        "DateFormat": "MM/DD/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "es-PY": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "es-SV": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "es-US": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "es-UY": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "es-VE": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "fr-BE": {
        "DateFormat": "D/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-BF": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-BI": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-BJ": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-BL": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-CA": {
        "DateFormat": "YYYY-MM-DD",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-CD": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-CF": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-CG": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-CH": {
        "DateFormat": "DD.MM.YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-CI": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-CM": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-DJ": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "fr-DZ": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "fr-FR": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-GA": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-GF": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-GN": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-GP": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-GQ": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-HT": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-KM": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-LU": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-MA": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-MC": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-MF": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-MG": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-ML": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-MQ": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-MR": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "fr-MU": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-NC": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-NE": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-PF": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-PM": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-RE": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-RW": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-SC": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-SN": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-SY": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "fr-TD": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "fr-TG": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-TN": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "fr-VU": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "fr-WF": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "fr-YT": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "pt-AO": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "pt-BR": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "pt-CH": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "pt-CV": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "pt-GQ": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "pt-GW": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "pt-LU": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "pt-MO": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A",
        "TimeFormatWithSeconds": "h:mm:ss A",
    },
    "pt-MZ": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "pt-PT": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "pt-ST": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "pt-TL": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "HH:mm",
        "TimeFormatWithSeconds": "HH:mm:ss",
    },
    "zh-CN": {
        "DateFormat": "YYYY/M/D",
        "TimeFormat": "h:mm A", // Adjusted for time picker
        "TimeFormatWithSeconds": "h:mm:ss A" // Adjusted for time picker
    },
    "zh-HK": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A", // Adjusted for time picker
        "TimeFormatWithSeconds": "h:mm:ss A" // Adjusted for time picker
    },
    "zh-Hans-HK": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A", // Adjusted for time picker
        "TimeFormatWithSeconds": "h:mm:ss A" // Adjusted for time picker
    },
    "zh-Hans-MO": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A", // Adjusted for time picker
        "TimeFormatWithSeconds": "h:mm:ss A" // Adjusted for time picker
    },
    "zh-MO": {
        "DateFormat": "D/M/YYYY",
        "TimeFormat": "h:mm A", // Adjusted for time picker
        "TimeFormatWithSeconds": "h:mm:ss A" // Adjusted for time picker
    },
    "zh-SG": {
        "DateFormat": "DD/MM/YYYY",
        "TimeFormat": "h:mm A", // Adjusted for time picker
        "TimeFormatWithSeconds": "h:mm:ss A" // Adjusted for time picker
    },
    "zh-TW": {
        "DateFormat": "YYYY/M/D",
        "TimeFormat": "h:mm A", // Adjusted for time picker
        "TimeFormatWithSeconds": "h:mm:ss A" // Adjusted for time picker
    },
};
